import React from 'react'
import { Typography, TypographyProps, useTheme } from '@mui/material'

interface CharacterCounterProps extends TypographyProps {
  text: string
  charLimit: number
}

const CharacterCounter: React.FC<CharacterCounterProps> = ({ text, charLimit, ...otherProps }) => {
  const theme = useTheme()

  return (
    <Typography variant="caption" sx={{ color: `${theme.palette.grey[500]}` }} {...otherProps}>
      {`${text.length}/${charLimit} characters`}
    </Typography>
  )
}

export default CharacterCounter
